var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", grow: "", shrink: "" } },
    [
      _c("w-row", { attrs: { center: "" } }, [_vm._t("default")], 2),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [_c("app-dossier-info-form", { attrs: { value: _vm.value } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }